import { collabboardModelSchema, studyAidSchema } from '@mio/shared';

import {
  AgentEvalPassKLab,
  AgentEvalTableLab,
  AgentEvalTraceLab,
  AgentEvalTrialsLab,
} from './agenteval-labs';
import { ApiCostLab, ApiExchangeLab, ApiFailuresLab, ApiFinishReasonsLab } from './api-labs';
import {
  ApproveAuditLab,
  ApprovePauseLab,
  ApproveRatingLab,
  ApproveResumeLab,
} from './approve-labs';
import { AuthGuessingLab, AuthLoginLab, AuthSaltLab, AuthStorageLab } from './auth-labs';
import { BrowserLayersLab, BrowserNetworkLab } from './browser-labs';
import { ChooseCacheLab, ChooseModelsLab, ChooseRouteLab, ChooseThinkingLab } from './choose-labs';
import {
  StateCompactLab,
  StateIdempotentLab,
  StateResumeLab,
  StateRowsLab,
} from './conversation-labs';
import {
  DatabaseConnectionLab,
  DatabaseIdentityLab,
  DatabaseParametersLab,
  DatabaseQueryLab,
  DatabaseSchemaLab,
  DatabaseScopeLab,
  DatabaseTransactionLab,
  DatabaseWritersLab,
} from './database-labs';
import { DecideGuardLab, DecideShapeLab, DecideTableLab, DecideTestLab } from './decide-labs';
import {
  EmbedHybridLab,
  EmbedPermissionLab,
  EmbedSimilarityLab,
  EmbedSpaceLab,
} from './embed-labs';
import { EvalCodingLab, EvalMatchLab, EvalRunLab, EvalSamplingLab } from './eval-labs';
import {
  ExperimentCompareLab,
  ExperimentLatencyLab,
  ExperimentRegressionLab,
  ExperimentSettingsLab,
} from './experiment-labs';
import {
  FeatureDecisionLab,
  FeatureDependencyLab,
  FeatureFlowLab,
  FeatureLogLab,
} from './feature-labs';
import { FlowChainLab, FlowCheckLab, FlowParallelLab, FlowRouteLab } from './flow-labs';
import { GroundAbstainLab, GroundCiteLab, GroundMetricsLab, GroundPromptLab } from './ground-labs';
import { InjectDefenseLab, InjectFlowLab, InjectTestLab, InjectTrifectaLab } from './inject-labs';
import { JudgeAgreementLab, JudgeCostLab, JudgeDriftLab, JudgeGradeLab } from './judge-labs';
import { KnowBudgetLab, KnowChunkLab, KnowKeywordLab, KnowMissLab } from './know-labs';
import {
  ConnectionScopeLab,
  DependencyDirectionLab,
  LayerSortLab,
  RefactorStepsLab,
} from './layer-labs';
import { LearningModelSurface } from './learning-model-surface';
import { MadeBenchmarkLab, MadeFamiliesLab, MadePreferenceLab, MadeStagesLab } from './made-labs';
import { KbPipelineLab, KbRerankLab, MemoryRecallLab, MemoryRowsLab } from './memory-labs';
import { ModelContextLab, ModelKnowledgeLab, ModelSamplingLab, ModelTokensLab } from './model-labs';
import { MultiCacheLab, MultiCostLab, MultiGuardrailLab, MultiHandoffLab } from './multi-labs';
import {
  HttpAgreementLab,
  HttpCommitLab,
  HttpFramingLab,
  HttpOutcomesLab,
  HttpRequestLab,
  HttpValidationLab,
  NetworksAddressesLab,
  NetworksConnectionLab,
  NetworksFailuresLab,
  NetworksOwnershipLab,
  NetworksStreamLab,
} from './network-discovery-labs';
import { FrameworkLab, HttpLab, StreamLab } from './network-labs';
import { OpsBackoffLab, OpsBudgetLab, OpsCacheLab, OpsFallbackLab } from './ops-labs';
import {
  OutputParseLab,
  OutputSchemaLab,
  OutputTruncationLab,
  OutputValidateLab,
} from './output-labs';
import {
  PatternChoiceLab,
  PatternPlanLab,
  PatternReactLab,
  PatternReflectLab,
} from './pattern-labs';
import {
  PermClientOnlyLab,
  PermMatrixLab,
  PermOwnershipLab,
  PermStatusLab,
} from './permission-labs';
import {
  PersistenceCommitLab,
  PersistenceLifetimeLab,
  PersistencePathsLab,
  PersistenceRepresentationLab,
  PersistenceSnapshotLab,
  PersistenceValidationLab,
  PersistenceWriteLab,
} from './persistence-labs';
import {
  PromptExamplesLab,
  PromptHistoryLab,
  PromptInjectionLab,
  PromptPartsLab,
} from './prompt-labs';
import { IdGuessingLab, KeysetPagingLab, LastManagerRaceLab, QueryFilterLab } from './query-labs';
import {
  ReactControlledLab,
  ReactEffectLab,
  ReactKeysLab,
  ReactLiftLab,
  ReactRenderLab,
  ReactRouterLab,
  ReactStaleLab,
} from './react-labs';
import { ConceptMap, RecallCards } from './reading-aids';
import {
  RelationshipDuplicationLab,
  RelationshipMembershipLab,
  RelationshipJoinsLab,
  RelationshipAssignmentLab,
  SchemaConstraintsLab,
  SchemaMigrationLab,
  SchemaTransactionLab,
  SchemaDeleteLab,
} from './relationship-labs';
import {
  BuildPipelineLab,
  ScriptTransformsLab,
  TypesCheckLab,
  TypesNarrowingLab,
} from './script-labs';
import {
  AuthClientStatesLab,
  CookieAttributesLab,
  SessionFlowLab,
  SessionStoreLab,
} from './session-labs';
import { ExecutionLab, PersistenceLab, RepresentationLab } from './state-labs';
import { StreamChoiceLab, StreamEventsLab, StreamFailureLab, StreamRelayLab } from './stream-labs';
import { DebugTraceLab, FixtureRollbackLab, OverrideFlowLab, TestCatchLab } from './testing-labs';
import { ToolBudgetLab, ToolDefinitionLab, ToolErrorLab, ToolLoopLab } from './tool-labs';
import {
  ToolDesignConsolidateLab,
  ToolDesignDescriptionLab,
  ToolDesignMcpLab,
  ToolDesignResultsLab,
} from './tooldesign-labs';
import {
  UnattendedCodingLab,
  UnattendedLimitsLab,
  UnattendedRunLab,
  UnattendedTriggerLab,
} from './unattended-labs';
import {
  ApiAcceptanceLab,
  ApiInputsLab,
  ApiLockingLab,
  ApiRegistrationLab,
  ApiResourcesLab,
  ApiResponsibilitiesLab,
  ApiValidationLab,
  WebActionsLab,
  WebAwaitLab,
  WebCreationLab,
  WebEventsLab,
  WebLayersLab,
  WebLayoutLab,
  WebOrderLab,
  WebOriginLab,
  WebReadStatesLab,
  WebRenderingLab,
  WebStructureLab,
  WebValuesLab,
} from './web-discovery-labs';

import './collabboard-labs.css';

const models = {
  representation: RepresentationLab,
  execution: ExecutionLab,
  persistence: PersistenceLab,
  'persistence-lifetime': PersistenceLifetimeLab,
  'persistence-paths': PersistencePathsLab,
  'persistence-representation': PersistenceRepresentationLab,
  'persistence-snapshot': PersistenceSnapshotLab,
  'persistence-validation': PersistenceValidationLab,
  'persistence-write': PersistenceWriteLab,
  'persistence-commit': PersistenceCommitLab,
  'database-writers': DatabaseWritersLab,
  'database-query': DatabaseQueryLab,
  'database-schema': DatabaseSchemaLab,
  'database-connection': DatabaseConnectionLab,
  'database-scope': DatabaseScopeLab,
  'database-parameters': DatabaseParametersLab,
  'database-transaction': DatabaseTransactionLab,
  'database-identity': DatabaseIdentityLab,
  'relationship-duplication': RelationshipDuplicationLab,
  'relationship-membership': RelationshipMembershipLab,
  'relationship-joins': RelationshipJoinsLab,
  'relationship-assignment': RelationshipAssignmentLab,
  'schema-constraints': SchemaConstraintsLab,
  'schema-migration': SchemaMigrationLab,
  'schema-transaction': SchemaTransactionLab,
  'schema-delete': SchemaDeleteLab,
  'script-transforms': ScriptTransformsLab,
  'types-check': TypesCheckLab,
  'types-narrowing': TypesNarrowingLab,
  'build-pipeline': BuildPipelineLab,
  'react-render': ReactRenderLab,
  'react-keys': ReactKeysLab,
  'react-controlled': ReactControlledLab,
  'react-lift': ReactLiftLab,
  'react-effect': ReactEffectLab,
  'react-stale': ReactStaleLab,
  'react-router': ReactRouterLab,
  'auth-storage': AuthStorageLab,
  'auth-guessing': AuthGuessingLab,
  'auth-salt': AuthSaltLab,
  'auth-login': AuthLoginLab,
  'session-flow': SessionFlowLab,
  'cookie-attributes': CookieAttributesLab,
  'session-store': SessionStoreLab,
  'auth-client-states': AuthClientStatesLab,
  'perm-matrix': PermMatrixLab,
  'perm-ownership': PermOwnershipLab,
  'perm-client-only': PermClientOnlyLab,
  'perm-status': PermStatusLab,
  'query-filter': QueryFilterLab,
  'id-guessing': IdGuessingLab,
  'last-manager-race': LastManagerRaceLab,
  'keyset-paging': KeysetPagingLab,
  'layer-sort': LayerSortLab,
  'dependency-direction': DependencyDirectionLab,
  'connection-scope': ConnectionScopeLab,
  'refactor-steps': RefactorStepsLab,
  'test-catch': TestCatchLab,
  'fixture-rollback': FixtureRollbackLab,
  'override-flow': OverrideFlowLab,
  'debug-trace': DebugTraceLab,
  'model-tokens': ModelTokensLab,
  'model-sampling': ModelSamplingLab,
  'model-knowledge': ModelKnowledgeLab,
  'model-context': ModelContextLab,
  'api-exchange': ApiExchangeLab,
  'api-finish-reasons': ApiFinishReasonsLab,
  'api-failures': ApiFailuresLab,
  'api-cost': ApiCostLab,
  'prompt-parts': PromptPartsLab,
  'prompt-examples': PromptExamplesLab,
  'prompt-history': PromptHistoryLab,
  'prompt-injection': PromptInjectionLab,
  'feature-flow': FeatureFlowLab,
  'feature-dependency': FeatureDependencyLab,
  'feature-log': FeatureLogLab,
  'feature-decision': FeatureDecisionLab,
  'eval-match': EvalMatchLab,
  'eval-run': EvalRunLab,
  'eval-coding': EvalCodingLab,
  'eval-sampling': EvalSamplingLab,
  'judge-grade': JudgeGradeLab,
  'judge-agreement': JudgeAgreementLab,
  'judge-drift': JudgeDriftLab,
  'judge-cost': JudgeCostLab,
  'experiment-compare': ExperimentCompareLab,
  'experiment-regression': ExperimentRegressionLab,
  'experiment-settings': ExperimentSettingsLab,
  'experiment-latency': ExperimentLatencyLab,
  'stream-events': StreamEventsLab,
  'stream-relay': StreamRelayLab,
  'stream-failure': StreamFailureLab,
  'stream-choice': StreamChoiceLab,
  'ops-cache': OpsCacheLab,
  'ops-budget': OpsBudgetLab,
  'ops-backoff': OpsBackoffLab,
  'ops-fallback': OpsFallbackLab,
  'flow-route': FlowRouteLab,
  'flow-chain': FlowChainLab,
  'flow-parallel': FlowParallelLab,
  'flow-check': FlowCheckLab,
  'decide-table': DecideTableLab,
  'decide-guard': DecideGuardLab,
  'decide-shape': DecideShapeLab,
  'decide-test': DecideTestLab,
  'tool-definition': ToolDefinitionLab,
  'tool-loop': ToolLoopLab,
  'tool-error': ToolErrorLab,
  'tool-budget': ToolBudgetLab,
  'tooldesign-description': ToolDesignDescriptionLab,
  'tooldesign-consolidate': ToolDesignConsolidateLab,
  'tooldesign-results': ToolDesignResultsLab,
  'tooldesign-mcp': ToolDesignMcpLab,
  'know-budget': KnowBudgetLab,
  'know-chunk': KnowChunkLab,
  'know-keyword': KnowKeywordLab,
  'know-miss': KnowMissLab,
  'embed-space': EmbedSpaceLab,
  'embed-similarity': EmbedSimilarityLab,
  'embed-hybrid': EmbedHybridLab,
  'embed-permission': EmbedPermissionLab,
  'ground-prompt': GroundPromptLab,
  'ground-cite': GroundCiteLab,
  'ground-abstain': GroundAbstainLab,
  'ground-metrics': GroundMetricsLab,
  'state-rows': StateRowsLab,
  'state-resume': StateResumeLab,
  'state-compact': StateCompactLab,
  'state-idempotent': StateIdempotentLab,
  'approve-rating': ApproveRatingLab,
  'approve-pause': ApprovePauseLab,
  'approve-resume': ApproveResumeLab,
  'approve-audit': ApproveAuditLab,
  'inject-flow': InjectFlowLab,
  'inject-trifecta': InjectTrifectaLab,
  'inject-defense': InjectDefenseLab,
  'inject-test': InjectTestLab,
  'agenteval-trials': AgentEvalTrialsLab,
  'agenteval-passk': AgentEvalPassKLab,
  'agenteval-trace': AgentEvalTraceLab,
  'agenteval-table': AgentEvalTableLab,
  'made-stages': MadeStagesLab,
  'made-preference': MadePreferenceLab,
  'made-families': MadeFamiliesLab,
  'made-benchmark': MadeBenchmarkLab,
  'choose-models': ChooseModelsLab,
  'choose-route': ChooseRouteLab,
  'choose-thinking': ChooseThinkingLab,
  'choose-cache': ChooseCacheLab,
  'pattern-react': PatternReactLab,
  'pattern-plan': PatternPlanLab,
  'pattern-reflect': PatternReflectLab,
  'pattern-choice': PatternChoiceLab,
  'memory-rows': MemoryRowsLab,
  'memory-recall': MemoryRecallLab,
  'kb-pipeline': KbPipelineLab,
  'kb-rerank': KbRerankLab,
  'multi-handoff': MultiHandoffLab,
  'multi-cost': MultiCostLab,
  'multi-guardrail': MultiGuardrailLab,
  'multi-cache': MultiCacheLab,
  'unattended-run': UnattendedRunLab,
  'unattended-limits': UnattendedLimitsLab,
  'unattended-trigger': UnattendedTriggerLab,
  'unattended-coding': UnattendedCodingLab,
  'output-parse': OutputParseLab,
  'output-validate': OutputValidateLab,
  'output-schema': OutputSchemaLab,
  'output-truncation': OutputTruncationLab,
  'networks-ownership': NetworksOwnershipLab,
  'networks-addresses': NetworksAddressesLab,
  'networks-connection': NetworksConnectionLab,
  'networks-stream': NetworksStreamLab,
  'networks-failures': NetworksFailuresLab,
  'http-agreement': HttpAgreementLab,
  'http-request': HttpRequestLab,
  'http-outcomes': HttpOutcomesLab,
  'http-framing': HttpFramingLab,
  'http-validation': HttpValidationLab,
  'http-commit': HttpCommitLab,
  'api-responsibilities': ApiResponsibilitiesLab,
  'api-registration': ApiRegistrationLab,
  'api-inputs': ApiInputsLab,
  'api-validation': ApiValidationLab,
  'api-resources': ApiResourcesLab,
  'api-acceptance': ApiAcceptanceLab,
  'api-locking': ApiLockingLab,
  'web-layers': WebLayersLab,
  'web-structure': WebStructureLab,
  'web-layout': WebLayoutLab,
  'web-values': WebValuesLab,
  'web-rendering': WebRenderingLab,
  'web-events': WebEventsLab,
  'web-origin': WebOriginLab,
  'web-await': WebAwaitLab,
  'web-read-states': WebReadStatesLab,
  'web-creation': WebCreationLab,
  'web-actions': WebActionsLab,
  'web-order': WebOrderLab,
  stream: StreamLab,
  http: HttpLab,
  framework: FrameworkLab,
  'browser-layers': BrowserLayersLab,
  'browser-network': BrowserNetworkLab,
};

export function CollabboardModel({ source }: { source: string }) {
  const model = collabboardModelSchema.safeParse(source.trim());
  if (!model.success)
    return (
      <p role="alert">
        This interactive model is unavailable. Continue with the explanation alongside it.
      </p>
    );
  const Model = models[model.data];
  return (
    <LearningModelSurface model={model.data}>
      <Model />
    </LearningModelSurface>
  );
}

export function StudyAidBlock({ source }: { source: string }) {
  try {
    const aid = studyAidSchema.parse(JSON.parse(source));
    return (
      <LearningModelSurface model={`study-aid-${aid.kind === 'map' ? 'map' : 'cards'}`}>
        {aid.kind === 'map' ? <ConceptMap aid={aid} /> : <RecallCards aid={aid} />}
      </LearningModelSurface>
    );
  } catch {
    return <p role="alert">This study aid is unavailable. Continue with the lesson explanation.</p>;
  }
}
